import React from 'react';
import { List } from 'antd';
import { Link } from 'react-router-dom';

import { Folder } from 'src/components/Icons';
import useFavorites from '../useFavorites';
import { FavoriteType } from '../constants';
import ListItem from '../ListItem';
import { getFolderLink } from '../utils';

const Folders: React.FC = () => {
  const { loading, entities } = useFavorites(FavoriteType.folders);

  console.log(entities);

  return (
    <List
      loading={loading}
      dataSource={entities}
      renderItem={(item) => {
        const href = getFolderLink(item);
        return (
          <ListItem
            key={item.id}
            title={item.name}
            icon={<Folder color="#d5c1ff" />}
            as={Link}
            to={href}
          />
        );
      }}
    />
  );
};

export default Folders;
